// Single source of truth for all legal/medical disclaimer copy.
// Edits made here propagate to the consent gate, footer, static pages,
// payment acknowledgments, and PDF reports.
// Source: docs/Legal Terms & Conditions.md

export const LEGAL_VERSION = '2026-04-30';
export const ENTITY_NAME = 'International ABA Institute, LLC';
export const PRODUCT_NAME = 'BEST Galaxy\u2122';

export const SHORT_DISCLAIMER =
  `${PRODUCT_NAME} provides educational insights into executive functioning ` +
  'and behavior patterns. It is not a medical or mental health diagnostic ' +
  'tool. Please consult a licensed professional for clinical concerns.';

export const INLINE_DISCLAIMER =
  'Educational insights only. Not medical or mental health advice.';

export const PAYMENT_ACK =
  'By purchasing, you acknowledge this is an educational product and not a clinical service.';

export const FULL_DISCLAIMER_TITLE = 'Legal & Medical Disclaimer';

export const FULL_DISCLAIMER_BODY = [
  `The ${PRODUCT_NAME}, including all assessments, reports, interpretations, and recommendations ` +
    `provided by ${ENTITY_NAME} and its affiliated programs, is intended for educational, ` +
    'informational, and personal development purposes only.',
  'This content is not intended to diagnose, treat, cure, or prevent any medical, psychological, or ' +
    'psychiatric condition. The information provided does not constitute medical advice, mental ' +
    'health counseling, or professional clinical services.',
  'Users are strongly encouraged to consult with a qualified physician, licensed mental health ' +
    'professional, or other appropriate healthcare provider regarding any medical or psychological ' +
    'concerns. Do not disregard or delay seeking professional advice based on information obtained ' +
    'through this platform.',
  `Participation in the ${PRODUCT_NAME} assessment and use of any associated reports or ` +
    'recommendations is voluntary. By engaging with this platform, you acknowledge and agree that:',
];

export const FULL_DISCLAIMER_BULLETS = [
  'You are solely responsible for your health, decisions, and actions.',
  `The ${PRODUCT_NAME} operates as a behavioral and educational framework, not a healthcare provider.`,
  'No guarantees are made regarding outcomes or results.',
  'Individual results may vary based on personal, environmental, and behavioral factors.',
];

export const FULL_DISCLAIMER_CLOSING =
  `To the fullest extent permitted by law, ${ENTITY_NAME} and its affiliates disclaim ` +
  'any liability for any direct, indirect, incidental, or consequential damages arising from the use ' +
  'or misuse of this platform, including but not limited to reliance on assessment results, reports, ' +
  'or recommendations.';

export const AGE_CONSENT_TEXT =
  'By proceeding, you confirm that you are at least 18 years of age, or ' +
  'that you are the parent/legal guardian consenting on behalf of a minor participant.';

export const CONSENT_CHECKBOXES = [
  {
    id: 'age_verification',
    required: true,
    label: AGE_CONSENT_TEXT,
  },
  {
    id: 'terms',
    required: true,
    label:
      `I have read and agree to the Terms of Service and Privacy Policy, and acknowledge that the ${PRODUCT_NAME} ` +
      'is for educational purposes only and does not provide medical or mental health advice.',
  },
  {
    id: 'responsibility',
    required: true,
    label:
      'I understand that I am responsible for my own decisions and that I should seek a licensed ' +
      'professional for medical or psychological concerns.',
  },
  {
    id: 'research',
    required: false,
    label:
      'I consent to my anonymized data being used for research and system improvement.',
  },
];

// NOTE: The full Terms of Service, Privacy Policy, Cookie Policy, and Ethical
// AI BEST Practices documents now live in `trustCenterContent.js` (the single
// source of truth, transcribed from the attorney-prepared PDFs). The short
// placeholder documents that used to live here have been removed to avoid
// duplicate/stale legal content.
